import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/News/VolantinoGare.png"
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import SpaceL from "../../commons/SpaceL";


function GareSociali2026 () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "30px" }}>
                Si avvisano i gentili clienti che
                <br/>
                in occasione delle gare sociali di nuoto
                <br/>
                l'intero centro rimarrà <strong>chiuso</strong>
            </p>
            <SpaceL/>
            <div className="container-foto-news m-auto d-none d-sm-block " style={{display: "flex", flexDirection: "column", width: "40%"}}>
                <img src={locandina} style={{width: "100%"}}/>
                <Space />
            </div>
            <div className="container-foto-news m-auto d-sm-none" style={{display: "flex", flexDirection: "column", width: "80%"}}>
                <img src={locandina} style={{width: "100%"}}/>
                <SpaceL />
            </div>
            <Space />

        </div>
    )
}
export default GareSociali2026